import { NgModule } from "@angular/core";
import { PowerBIModule } from "./power-bi/power-bi.module";

@NgModule({
  declarations: [],
  imports: [PowerBIModule],
})
export class IntegrationsModule {}
